import * as React from "react";

interface IProps {
  size: number;
  color?: string;
}
const Tag: React.FC<IProps> = ({ size, color = undefined }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.31 15.023l6.44 6.44 4.714-4.713-6.44-6.44-3.93.785-.785 3.928zm-1.81.548l8.25 8.25 7.07-7.071-8.249-8.25L9.68 9.679 8.5 15.57z"
        fill={color}
      />
    </svg>
  );
};

export default Tag;
